import { toast } from "sonner";
import CustomButton from "../CustomButton";
import CustomInput from "../CustomInput";
import ModalLayout from "../layouts/ModalLayout";
import { useState } from "react";

interface Props {
  onClose?: () => void;
}

export default function ScheduleMessage({ onClose }: Props) {
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");

  const handleInputChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = event.target;

    if (name === "date") setScheduleDate(value);
    if (name === "time") setScheduleTime(value);
  };

  const handleScheduleSubmit = () => {
    if (!scheduleDate || !scheduleTime) {
      toast.error("Please select both date and time to schedule the message.");
      return;
    }

    toast.success(`Message scheduled for ${scheduleDate} at ${scheduleTime}`);
    onClose?.();
  };

  return (
    <ModalLayout onClose={onClose}>
      <form
        className="flex flex-col gap-4  bg-white rounded-lg"
        onSubmit={(e) => e.preventDefault()}
      >
        <h2 className="text-lg font-semibold text-neutral-700">
          Schedule Message
        </h2>

        <CustomInput
          name="date"
          label="Select Date"
          type="date"
          value={scheduleDate}
          onChange={handleInputChange}
          inputClassName="w-full"
        />

        <CustomInput
          name="time"
          label="Select Time"
          type="time"
          value={scheduleTime}
          onChange={handleInputChange}
          inputClassName="w-full"
        />

        <div className="flex justify-end items-end gap-5 mt-4">
          <CustomButton
            color="bg-neutral-200"
            text="Cancel"
            onClick={onClose}
          />
          <CustomButton
            color="bg-primary-500"
            text="Schedule"
            onClick={handleScheduleSubmit}
          />
        </div>
      </form>
    </ModalLayout>
  );
}
